<!-- Zweck: Stellt die HTML-Struktur für shop customer special price edit button component im Frontend bereit. -->
<span>
  <button (click)="click()" [disabled]="disabled"
          mat-button matTooltip="Kundensonderpreis bearbeiten">
    <svg-icon
      color="{{disabled ? 'grey' : 'orange'}}">
      sonderpreis
    </svg-icon>
  </button>
</span>
